const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID;

export function initClarity() {
  if (!CLARITY_PROJECT_ID) return;

  if (window.clarity) return;

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };

    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;

    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
}

export function clarityEvent(eventName) {
  if (!window.clarity) return;
  window.clarity("event", eventName);
}

export function claritySetTag(key, value) {
  if (!window.clarity) return;
  window.clarity("set", key, value);
}